import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferralFromSearch } from 'utils/referralStorage';

export default function useReferralCapture({ skipWhenAuthenticated = false } = {}) {
  const location = useLocation();

  useEffect(() => {
    if (skipWhenAuthenticated) {
      return;
    }
    captureReferralFromSearch(location.search);
  }, [location.search, skipWhenAuthenticated]);
}
